module.exports = __webpack_public_path__ + "static/media/story_19.f9f4cb6b.jpg";